import React from 'react';
import {GlobalStyles} from '@mui/material';

/** Put on the window content; the modal paper around it turns white. */
export const WHITE_PAPER_CLASS_SYNC = 'syncWhitePaper'

/** The shared modal paper is grey and takes no prop for it, so it is recoloured by its content. */
const WhitePaperSync = () => (
	<GlobalStyles styles={(theme) => ({
		[`.MuiPaper-root:has(.${WHITE_PAPER_CLASS_SYNC})`]: {
			backgroundColor: `${theme.palette.background.paper} !important`,
		},
	})}/>
)

export default WhitePaperSync;
